var lib_core = require("lib-core");

/**
 * @constructor
 */
var MasterStateMachine = function (root, model) {
    var self = this;
    this.root = root;
    this.model = model;

    this.errorShownForMs = 3000;

    lib_core.StateMachine.call(this);
};
lib_core.inherit(MasterStateMachine, lib_core.StateMachine);

module.exports = MasterStateMachine;

MasterStateMachine.prototype.addTab = function (tab) {
    var self = this;

    var tab_name = tab.name();

    this.model.tabs.forEach(function (idx, tab) {
        if (tab_name !== tab.name()) {
            self.addTransition(tab_name, tab.name(),
                function (cEvent) {
                    return cEvent.type() == lib_core.GuiEvents.SWITCH_TAB && cEvent.data('tab') == tab.name();
                },
                function (cEvent) {
                    self.model.activeTab(tab.name());
                }
            );
            self.addTransition(tab.name(), tab_name,
                function (cEvent) {
                    return cEvent.type() == lib_core.GuiEvents.SWITCH_TAB && cEvent.data('tab') == tab_name;
                },
                function (cEvent) {
                    self.model.activeTab(tab_name);
                }
            );
        }
    });

};

